import { useTranslation } from 'react-i18next'

interface TranslationEntityEditActionProps {
  onEdit: () => void
  ariaLabel: string
}

/** The "Modifier" action on one drill-down row (a lead or a fact) — opens
 * the existing edit dialog for that entity. Reuses the same visible label as
 * the dashboard's investigation-level edit link
 * (`translations.dashboard_edit_link`); `ariaLabel` disambiguates the
 * several identically-labelled buttons a table can hold. */
export function TranslationEntityEditAction({
  onEdit,
  ariaLabel,
}: TranslationEntityEditActionProps) {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      className="text-primary hover:underline text-xs"
      onClick={onEdit}
      aria-label={ariaLabel}
    >
      {t('translations.dashboard_edit_link')}
    </button>
  )
}
